module.exports = __webpack_public_path__ + "static/media/titlecard_customerfeedback.9e92b894.jpg";